// extracted by mini-css-extract-plugin
export var item = "RuledList-module--item--bFEzm";
export var list = "RuledList-module--list--yMqLu";
export var ruleBottom = "RuledList-module--ruleBottom--E1jxe";
export var ruleTop = "RuledList-module--ruleTop--oihMC";